import { customElement, useView, PLATFORM } from 'aurelia-framework';
import { BindingEngine } from 'aurelia-binding';
import { CustomerService, WidgetBase, WidgetPropertyType, property, widget } from '@dynamik/common';
import { ReportPageElement } from '../../report-page/report-page';

@customElement('page-number-widget')
@useView(PLATFORM.moduleName('./page-number-widget.html'))
@widget('Page number', true, true, 'Page number in a report')
export class PageNumberWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine, public reportPageElement: ReportPageElement) {
    super(element, bindingEngine, customerService);
  }

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number;

  @property('Text')
  fontWeight?: string;

  @property('Text')
  color?: string;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: 'left' | 'center' | 'right';
}
